import React, {ReactElement} from 'react';
import moneyReceiveSrc from '@assets/images/medops/money-receive.svg';

const MoneyReceive = (props: any): ReactElement => {
  return <img src={moneyReceiveSrc} {...props} />;
};
export default MoneyReceive;
